import { render, staticRenderFns } from "./day.vue?vue&type=template&id=477a4bcc&scoped=true"
import script from "./day.vue?vue&type=script&lang=js"
export * from "./day.vue?vue&type=script&lang=js"
import style0 from "./day.vue?vue&type=style&index=0&id=477a4bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a4bcc",
  null
  
)

export default component.exports